import script from "./AdminSettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSettingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminSettingsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__